import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="paypal-search"
export default class extends Controller {
  static targets = [
    "newApplicantForm",
    "paymentOptionsContainer",
    "paymentOption",
    "finalizeSignup"
  ]

  connect() {
    this.hidePaymentOptionsContainer()
    this.hideNewApplicantForm()
    this.handlePersonSelection()
  }

  hidePaymentOptionsContainer() {
    if (this.hasPaymentOptionsContainerTarget) {
      this.paymentOptionsContainerTarget.style.display = "none"
    }
  }

  hideNewApplicantForm() {
    if (this.hasNewApplicantFormTarget) {
      this.newApplicantFormTarget.style.display = "none"
    }
  }

  handlePersonSelection(_event) {
    const selectedOption = this.getSelectedOption()

    if (!selectedOption) return

    const memberType = this.getMemberType(selectedOption)

    this.setPaymentOptions(memberType)
    this.showPaymentOptionsContainer()
    this.renderPaymentOption(memberType)
    this.handleNewApplicantForm(selectedOption)
    this.scrollToFinalizeSignup()
  }

  getSelectedOption() {
    return this.element.querySelector('input[name="person_id"]:checked')
  }

  getMemberType(option) {
    const type = option.dataset.memberType?.toLowerCase()

    if (['member', 'lifetime'].includes(type)) return 'member'
    if (type === 'applicant-new') return 'applicant-new'
    return 'applicant'
  }

  setPaymentOptions(memberType) {
    // Hide all payment options
    const allOptions = this.element.querySelectorAll('.payment-option')
    allOptions.forEach(option => {
      option.style.display = "none"
    })

    // Show options for this member type
    const relevantOptions = this.element.querySelectorAll(`.payment-option.${memberType}`)
    relevantOptions.forEach(option => {
      option.style.display = "block"
    })
  }

  showPaymentOptionsContainer() {
    if (this.hasPaymentOptionsContainerTarget) {
      this.paymentOptionsContainerTarget.style.display = "block"
      // Add smooth transition
      this.paymentOptionsContainerTarget.style.transition = "opacity 0.5s"
      this.paymentOptionsContainerTarget.style.opacity = "1"
    }
  }

  renderPaymentOption(memberType) {
    if (!this.hasPaymentOptionTarget) return

    const template = this.element.querySelector(`script#${memberType}`)
    if (template) {
      this.paymentOptionTarget.innerHTML = template.innerHTML
    }
  }

  handleNewApplicantForm(option) {
    const isNewApplicant = option.dataset.memberType === 'applicant-new'

    if (isNewApplicant) {
      this.showNewApplicantForm()
    } else {
      this.hideNewApplicantFormAnimated()
    }
  }

  showNewApplicantForm() {
    if (this.hasNewApplicantFormTarget) {
      this.newApplicantFormTarget.style.display = "block"
      this.newApplicantFormTarget.style.transition = "opacity 0.5s"
      this.newApplicantFormTarget.style.opacity = "1"
    }
  }

  hideNewApplicantFormAnimated() {
    if (this.hasNewApplicantFormTarget) {
      this.newApplicantFormTarget.style.opacity = "0"
      setTimeout(() => {
        this.newApplicantFormTarget.style.display = "none"
      }, 500)
    }
  }

  scrollToFinalizeSignup() {
    if (this.hasFinalizeSignupTarget) {
      setTimeout(() => {
        this.finalizeSignupTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }, 300)
    }
  }
}
